module.exports = __webpack_public_path__ + "static/media/ann-icon.80f82bb2.png";